import { FC, useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation, { TNavigation } from 'src/components/navigation/Navigation';
import useSideNavigationItems from 'src/components/navigation/useSideNavigationItems';
import { TCreateMVPRequest } from 'src/services/apiEndpoint.types.ts/ideaHub/createIdea.endpoint.types';
import { getTeamCohort } from 'src/store/cohort/cohort.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { createMVP } from 'src/store/ideaHub/createMVP.thunk';
// import { createMVP } from 'src/store/ideaHub/ideaHub.slice';
import { useSideNavItems } from 'src/utils';

const PublicLayout: FC = () => {
  // hooks 
  const sideNavItems = useSideNavItems();
  const { isAuthorized } = useAppSelector((store) => store.auth);
  const { viewUserCohort } = useAppSelector(
    (store) => store.cohort
  );
  const { profile } = useAppSelector((store) => store.profile);
  const { myCompany } = useAppSelector((store) => store.company);
  const email = profile?.email || myCompany?.email;
  const userType = profile?.email ? 'User' : 'Company';
  const dispatch = useAppDispatch()
  const {
    id: userId
  } = useAppSelector((store) => store.profile.profile);

  const {
    type
  } = useAppSelector((store) => store.company.myCompany);
  const location = useLocation();

  // state
  const [loading, setLoading] = useState<boolean>(false)
  const [items, setItems] = useState<Array<TNavigation>>(sideNavItems);
  // constant or derived state 
  const exculdedPath = ['/dashboard', '/', '/privacy-policy', '/payment-policy', '/contact-us', '/for-investors', '/access-denied', '/success', '/keymember-verification', '/apply-to-program-external', '/apply-to-event-external', '/feedback', '/check-password', '/application-rating', '/apply-to-program', '/survey-report', '/demo-day', '/demo-day-register', '/demo-day-register/payment', '/demo-day-register/document-submission', '/demo-day-register/slot-booking', '/demo-day-register/success', '/demo-day-detail', '/not-found', '/scoring-engine', '/newpage']
  const isCompany = type === 'Accelerator' || type === 'Incubator' || type === 'Pre-Incubator' || type === 'E-Cell'
  const isSidebarInclude = useMemo(() => {
    return !exculdedPath.includes(location.pathname)
  }, [location])

  // effect
  useEffect(() => {
    if (userId) {
      // dispatch(getTeamCohort({ userId }))
    }
  }, [JSON.parse(JSON.stringify(userId))])
  function handleNavigateToMVP() {
    const payload: TCreateMVPRequest = {
      email,
      userType
    }
    setLoading(true)
    dispatch(createMVP(payload)).then((response: any) => {
      setLoading(false)
      if (response?.data?.data?.tokenUrl) {
        window.open(response?.data?.data?.tokenUrl)
      }
    }).finally(() => setLoading(false))
  }
  useEffect(() => {
    const arr: TNavigation[] = [];
    sideNavItems.forEach((item: any) => {
      item.state = item.state === 'disabled' ? 'disabled' : 'default';
      if (location.pathname.includes(item.url)) item.state = 'active';
      if (item.key === 'cohort' && viewUserCohort) {
        const teamId = viewUserCohort?.CohortTeamsAndTeamMemberMappings?.[0]?.cohortTeamId
        arr.push({ ...item, url: `/cohort?id=${viewUserCohort.id}&userId=${userId}&teamId=${teamId}` })
      }
      if ((item.key === 'chat' && !isAuthorized) || (isCompany && (item.key === 'resources' || item.key === 'idea-hub'))) {
        return
      }
      item.key !== 'cohort' && arr.push(item)
    });
    setItems(arr);
  }, [location, isAuthorized, userId, viewUserCohort, type, sideNavItems]);

  return (
    <>
      {isSidebarInclude ? <div className="protected-layout">
        <Navigation items={items} handleNavigateToMVP={handleNavigateToMVP} loading={loading} />
        <div className="protected-layout__right">
          <Outlet />
        </div>
      </div> : (
        <Outlet />
      )}
    </>
  );
};

export default PublicLayout;
